<template>
  <div id="dropzone-root" class="gk-vue-dropzone">
    <div v-show="!hideZone && !file && !fileUrl" id="dropzone" class="dropzone dz-clickable" :class="file ? 'dropzone-border-none dz-started dz-max-files-reached' : 'dropzone-border'">
      <div class="dropzone-hint">
        <font-awesome-icon icon="fa-solid fa-image-slash" class="dropzone-hint-icon" />
      </div>
    </div>
    <div id="dropzonePreview" v-show="!hidePreview && preloaded_file" class="dropzone dz-default dz-file-preview dropzone-border-none dropzone-preview dropzone-preview-image">
      <ImageViewer :zoomable="true" :file-path="preloaded_file" ref="previewImage" />
    </div>
  </div>
</template>

<script>
import customAxios from '../../store/services/axiosConfig'
import ImageViewer from '@/components/ui/ImageViewer'

export default {
  name: 'ImageDropzone',
  components: { 
    ImageViewer,
  },
  props: {
    preloaded_file: {
      type: String,
      default: null,
    },
    image_field_name: {
      type: String,
      default: null,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
    hideZone: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      file: null,
      fileUrl: null,
      imageDropzone: null,
      initialized: false,
      defaultOptions: {
        method: 'patch',
        thumbnailWidth: null,
        acceptedFiles: 'image/*',
        thumbnailHeight: null,
        thumbnailMethod: 'contain',
        autoProcessQueue: false,
        maxFiles: 1,
        url: 'www.com',
        clickable: ['#dropzone'],
        headers: {
          'X-CSRFToken': document.head.querySelector('[name~=csrftoken][content]').content
        }
      }
    }
  },
  computed: {
    dropzoneOptions () {
      const options = {
        ...this.defaultOptions,
        ...this.options
      }
      // Merge `clickable` arrays if both exist
      if (Array.isArray(this.defaultOptions.clickable) && Array.isArray(this.options.clickable)) {
        options.clickable = [...this.defaultOptions.clickable, ...this.options.clickable]
      }
      return options
    }
  },
  watch: {
    preloaded_file (newVal, oldVal) {
      this.initDropzone()
      if (oldVal !== newVal) {
        this.displayExistingFile(newVal)
      }
    }
  },
  created () {
    this.setupData()
  },
  mounted () {
    this.initDropzone()
  },
  methods: {
    setupData () {
      // console.log(this.dropzoneOptions)
    },
    initDropzone () {
      if (!this.imageDropzone && !this.initialized) {
        this.initialized = true
        this.initialize()
      }
      if (this.preloaded_file) {
        this.displayExistingFile(this.preloaded_file)
      }
    },
    displayExistingFile (file) {
      if (!this.hidePreview) {
        this.fileUrl = file
        const mockFile = { name: 'filename', size: 12345, mock: true }
        const callback = null
        const crossOrigin = null
        const resizeThumbnail = false
        this.imageDropzone.displayExistingFile(mockFile, this.fileUrl, callback, crossOrigin, resizeThumbnail);
      }
    },
    downloadFile (fileUrl) {
      window.open(fileUrl)
    },
    initialize () {
      window.Dropzone.autoDiscover = false
      this.imageDropzone = new window.Dropzone(this.$el, this.dropzoneOptions)
      this.attachDropzoneEvents()
    },
    attachDropzoneEvents () {
      this.imageDropzone.on('success', (file, response) => {
        console.log('ImageDropzone::success')
        this.$emit('uploaded', response)
      })
      this.imageDropzone.on('maxfilesexceeded', (file) => {
        this.removeAllFiles()
        this.addFile(file)
      })
      this.imageDropzone.on('addedfile', (file, response) => {
        if (file.mock || !file.type.includes('image/')) {
          return false
        }
        if (!file.mock) {
          if (this.file) {
            this.removeImage()
          }
          this.file = file
          console.log('ImageDropzone::addedfile()', this.file)
          this.$emit('change', this.file)
        }
      })
      if (!this.hidePreview) {
        this.imageDropzone.on('thumbnail', (file, dataURL) => {
          this.$refs.previewImage.updateFilePath(dataURL)
        })
      }
      this.imageDropzone.on('sending', (file, xhr, formData) => {
        console.log('ImageDropzone::sending')
        // TODO add loadingSpinner
        this.$emit('sending', false)
        formData.append(this.image_field_name, file);
      })
    },
    removeImage () {
      this.file = null
      this.fileUrl = null
      this.imageDropzone.removeAllFiles()

      this.$emit('removed', false)

      if (this.dropzoneOptions.autoProcessQueue) {
        if (this.dropzoneOptions.delete_url) {
          customAxios.delete(this.dropzoneOptions.delete_url)
        } else if (this.dropzoneOptions.url !== 'www.com' && this.dropzoneOptions.method === 'patch') {
          var data = {}
          data[this.image_field_name] = null
          customAxios.patch(this.dropzoneOptions.url, data)
        }
      }
    }
  }
}
</script>

<style lang="scss">
  
</style>
<style lang="scss" scoped>

</style>